'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var filterShape = _react.PropTypes.shape({
  value: _react.PropTypes.string,
  count: _react.PropTypes.number,
  label: _react.PropTypes.string
});

exports.default = filterShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/filterShape.js
// module id = 69
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16